"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATOR_IDs = exports.ValidatorID = void 0;
var ValidatorID;

(function (ValidatorID) {
  ValidatorID["API_SERVICE_DISCONNECTED"] = "API_SERVICE_DISCONNECTED";
  ValidatorID["API_SERVICE_CONNECTION_ERROR"] = "API_SERVICE_CONNECTION_ERROR";
  ValidatorID["MISSING_ROLE"] = "MISSING_ROLE";
  ValidatorID["MISSING_BINDING_TO_SERVICE_ACCOUNT"] = "MISSING_BINDING_TO_SERVICE_ACCOUNT";
  ValidatorID["MISSING_CONTAINER_TO_SERVICE_ACCOUNT"] = "MISSING_CONTAINER_TO_SERVICE_ACCOUNT";
  ValidatorID["MISSING_PSP"] = "MISSING_PSP";
  ValidatorID["MISSING_VOLUME_MOUNT_CONFIG_MAP"] = "MISSING_VOLUME_MOUNT_CONFIG_MAP";
  ValidatorID["MISSING_ENV_CONFIG_MAP"] = "MISSING_ENV_CONFIG_MAP";
  ValidatorID["MISSING_ENV_CONFIG_MAP_KEY"] = "MISSING_ENV_CONFIG_MAP_KEY";
  ValidatorID["MISSING_VOLUME_MOUNT_SECRET"] = "MISSING_VOLUME_MOUNT_SECRET";
  ValidatorID["MISSING_ENV_SECRET"] = "MISSING_ENV_SECRET";
  ValidatorID["MISSING_ENV_SECRET_KEY"] = "MISSING_ENV_SECRET_KEY";
  ValidatorID["MISSING_SVC_ACCOUNT_SECRET"] = "MISSING_SVC_ACCOUNT_SECRET";
  ValidatorID["MISSING_PVC"] = "MISSING_PVC";
  ValidatorID["MISSING_PV"] = "MISSING_PV";
  ValidatorID["MISSING_HPA_APP"] = "MISSING_HPA_APP";
  ValidatorID["MISSING_SERVICE_APP"] = "MISSING_SERVICE_APP";
  ValidatorID["MISSING_INGRESS_SERVICE"] = "MISSING_INGRESS_SERVICE";
  ValidatorID["MISSING_INGRESS_SERVICE_PORT"] = "MISSING_INGRESS_SERVICE_PORT";
  ValidatorID["EMPTY_ENV_CONFIG_MAP"] = "EMPTY_ENV_CONFIG_MAP";
  ValidatorID["EMPTY_ENV_SECRET"] = "EMPTY_ENV_SECRET";
  ValidatorID["UNSET_SERVICE_ACCOUNT"] = "UNSET_SERVICE_ACCOUNT";
  ValidatorID["UNOWNED_REPLICA_SET"] = "UNOWNED_REPLICA_SET";
  ValidatorID["UNOWNED_POD"] = "UNOWNED_POD";
  ValidatorID["SERVICE_MULTIPLE_APPS"] = "SERVICE_MULTIPLE_APPS";
  ValidatorID["SERVICE_MISSING_PORT"] = "SERVICE_MISSING_PORT";
  ValidatorID["INGRESS_NOT_MOUNT_TO_APPS"] = "INGRESS_NOT_MOUNT_TO_APPS";
  ValidatorID["UNUSED_CONFIG_MAP"] = "UNUSED_CONFIG_MAP";
  ValidatorID["UNUSED_SECRET"] = "UNUSED_SECRET";
  ValidatorID["UNUSED_SERVICE_ACCOUNT"] = "UNUSED_SERVICE_ACCOUNT";
  ValidatorID["UNUSED_ROLE_BINDING"] = "UNUSED_ROLE_BINDING";
  ValidatorID["UNUSED_ROLE"] = "UNUSED_ROLE";
  ValidatorID["UNUSED_PVC"] = "UNUSED_PVC";
  ValidatorID["UNUSED_PV"] = "UNUSED_PV";
  ValidatorID["POD_LIFECYCLE"] = "POD_LIFECYCLE";
  ValidatorID["POD_STATUS_NOT_SCHEDULED"] = "POD_STATUS_NOT_SCHEDULED";
  ValidatorID["POD_STATUS_NOT_CONTAINERS_READY"] = "POD_STATUS_NOT_CONTAINERS_READY";
  ValidatorID["POD_STATUS_NOT_INITIALIZED"] = "POD_STATUS_NOT_INITIALIZED";
  ValidatorID["POD_STATUS_NOT_READY"] = "POD_STATUS_NOT_READY";
  ValidatorID["POD_STATUS_OTHER_CONDITION"] = "POD_STATUS_OTHER_CONDITION";
  ValidatorID["TRAEFIK_MISSING_MIDDLEWARE"] = "TRAEFIK_MISSING_MIDDLEWARE";
  ValidatorID["TRAEFIK_MISSING_SERVICE"] = "TRAEFIK_MISSING_SERVICE";
  ValidatorID["TRAEFIK_MISSING_TLS_OPTIONS"] = "TRAEFIK_MISSING_TLS_OPTIONS";
  ValidatorID["TRAEFIK_UNUSED_MIDDLEWARE"] = "TRAEFIK_UNUSED_MIDDLEWARE";
  ValidatorID["TRAEFIK_UNUSED_SERVICE"] = "TRAEFIK_UNUSED_SERVICE";
  ValidatorID["TRAEFIK_UNUSED_TLS_OPTIONS"] = "TRAEFIK_UNUSED_TLS_OPTIONS";
})(ValidatorID = exports.ValidatorID || (exports.ValidatorID = {}));

exports.VALIDATOR_IDs = [];

for (var key in ValidatorID) {
  exports.VALIDATOR_IDs.push(key);
}